import { Badge } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { useFormRowContext } from './FormRowContext';

export const BadgesCell = () => {
  const {
    form: {
      active,
      template: { oneWay },
    },
  } = useFormRowContext();
  const { t } = useTranslation('forms');
  return (
    <td>
      <Badge color={active ? 'green' : 'gray'}>
        {active
          ? t('listView.tableRow.badges.active')
          : t('listView.tableRow.badges.inactive')}
      </Badge>
      {oneWay && (
        <Badge sx={theme => ({ marginLeft: theme.other.spacing(1) })}>
          {t('listView.tableRow.badges.oneWay')}
        </Badge>
      )}
    </td>
  );
};
